module.exports = __webpack_public_path__ + "static/logo-1024-a5a0515ddf97f4008b430be88d2f3449.png";